import { Component, inject } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { TranslateService } from "@ngx-translate/core";
import { RouterOutlet } from "@angular/router";
import { MessagingComponent } from "@otimo/messaging";
import { LangService } from "@otimo/report-base";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.css"],
    imports: [MessagingComponent, RouterOutlet]
})
export class AppComponent {
    private readonly lang = inject(LangService);
    private readonly translate = inject(TranslateService);
    private readonly titleService = inject(Title);

    constructor() {
        this.lang.init(["sv", "en"]);

        this.translate.onLangChange.subscribe(() => {
            this.translate.get("header.title").subscribe((text: string) => {
                this.titleService.setTitle(text);
            });
        });
    }
}
